// Shared constants/helpers for the Redfin-style search workspace.

export const CATEGORIES = [
  { v: "PLOT", l: "Plots" },
  { v: "LAND", l: "Land" },
  { v: "HOUSE", l: "Houses" },
  { v: "VILLA", l: "Villas" },
  { v: "FLAT", l: "Apartments" },
  { v: "COMMERCIAL", l: "Commercial" },
  { v: "PG_HOSTEL", l: "PG/Hostel" },
];

export const FACING = ["North", "South", "East", "West", "North-East", "North-West", "South-East", "South-West"];

export const FURNISHED = [
  { v: "FULLY_FURNISHED", l: "Furnished" },
  { v: "SEMI_FURNISHED", l: "Semi-Furnished" },
  { v: "UNFURNISHED", l: "Unfurnished" },
];

export const SORT = [
  { v: "newest", l: "Newest" },
  { v: "price_asc", l: "Price (Low to High)" },
  { v: "price_desc", l: "Price (High to Low)" },
  { v: "area_desc", l: "Largest First" },
  { v: "verified_first", l: "Verified First" },
  { v: "most_viewed", l: "Most Viewed" },
  { v: "road_width_desc", l: "Widest Road First" },
  { v: "price_per_area_asc", l: "₹/Area (Low to High)" },
];

export const AMENITIES = ["Boundary Wall", "Gated Colony", "Electricity", "Water", "Drainage", "Road Access", "Parking", "Security", "Garden", "Gym", "Swimming Pool", "Club House", "Power Backup", "Lift", "CCTV"];

export const AREA_UNITS = [
  { v: "sqft", l: "Sq. Ft" },
  { v: "sqyd", l: "Sq. Yard" },
  { v: "sqm", l: "Sq. Meter" },
  { v: "acre", l: "Acre" },
  { v: "hectare", l: "Hectare" },
  { v: "bigha", l: "Bigha" },
  { v: "katha", l: "Katha" },
];

export const OWNERSHIP = ["freehold", "leasehold", "co_operative", "power_of_attorney"];

export const PRICE_STEPS = [500000, 1000000, 2000000, 3000000, 5000000, 7500000, 10000000, 15000000, 20000000, 30000000, 50000000, 100000000];

export function shortPrice(n) {
  const amount = Number(n);
  if (!Number.isFinite(amount) || amount <= 0) return "";
  if (amount >= 1_00_00_000) {
    const cr = amount / 1_00_00_000;
    return `₹${cr % 1 === 0 ? cr.toFixed(0) : cr.toFixed(1)}Cr`;
  }
  if (amount >= 1_00_000) return `₹${Math.round(amount / 1_00_000)}L`;
  return `₹${Math.round(amount / 1000)}K`;
}

export function readParams(sp) {
  const out = {};
  for (const [k, v] of sp.entries()) {
    if (k === "amenities") out[k] = v.split(",").filter(Boolean);
    else out[k] = v;
  }
  return out;
}

// Filters counted for the "Filters" badge — everything beyond the toolbar quick controls.
const DRAWER_FILTER_KEYS = [
  "locality", "facing", "ownership_type", "corner_plot", "registry_available",
  "mutation_available", "verified_documents", "verified_owner", "furnished",
];

export function countDrawerFilters(params) {
  let count = DRAWER_FILTER_KEYS.filter((key) => params[key]).length;
  if (params.amenities?.length) count += 1;
  return count;
}

export function isLandCategory(category) {
  return !category || ["LAND", "PLOT"].includes(String(category).toUpperCase());
}
